import { useTranslation } from 'react-i18next';
import { IOperationChildcare } from '@/common/integrations/menhir/employee/operations/operations.types';
import { useGetVoucher } from '@/common/integrations/menhir/employee/vouchers/vouchers.hooks';
import { ChildcareVoucherInfo } from '@/web/components/ChildcareVoucherInfo/ChildcareVoucherInfo';
import { OperationDetailDrawer } from '@/web/components/TransactionList/components/OperationDetail/components/OperationDetailDrawer/OperationDetailDrawer';
import { Badge, Flex } from '@coverflex-tech/hypernova';

interface IChildcareDetailProps {
  operation: IOperationChildcare;
}

export const ChildcareDetailDrawer = ({ operation }: IChildcareDetailProps) => {
  const { t } = useTranslation();

  const { voucher, isInitialLoading } = useGetVoucher({
    type: 'childcare',
    voucherId: operation.childcareVoucher.id,
  });

  if (isInitialLoading) {
    return (
      <OperationDetailDrawer
        operation={operation}
        title={t('general.labels.transaction')}
        isLoading
      />
    );
  }

  if (!voucher) {
    throw new Error('Voucher required');
  }

  const isPaid = !!voucher.paidAt;

  return (
    <OperationDetailDrawer
      operation={operation}
      title={t('operations.detail.childcare_label', {
        beneficiary: voucher?.beneficiary.shortName,
      })}
    >
      <Flex flexDirection="column" gap="xl">
        <div>
          <Badge status={isPaid ? 'success' : 'info'} size="lg">
            {isPaid ? t('general.status.paid') : t('general.status.pending')}
          </Badge>
        </div>
        <ChildcareVoucherInfo voucher={voucher} />
      </Flex>
    </OperationDetailDrawer>
  );
};
